const options = {
  nav: true,
  navSpeed: 200,
  dots: false,
  dotsSpeed: 200,
  items: 3,
  slideBy: 3,
  rewind: false,
  responsive: {
    0: {
      items: 3,
      slideBy: 1,
      stagePadding: 15
    },
    768: {
      items: 2,
      slideBy: 1,
      stagePadding: 0,
      margin: 50
    },
    1200: {
      items: 2,
      slideBy: 1,
      stagePadding: 0,
      margin: 50
    },
    1600: {
      items: 2,
      slideBy: 1,
      stagePadding: 0,
      margin: 50
    }
  }
}

export default options
